<template>
  <nav
    class="navbar is-gradient"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="container">
      <!-- <div class="navbar-brand is-inline-flex-mobile is-inline-flex-tablet">
        <div class="navbar-item" @click="onClickTitle">
          <h2 class="is-size-3-desktop is-size-4-mobile">
            Compara precios de 100+ tiendas
          </h2>
        </div>
      </div> -->
      <div class="navbar-end is-inline-flex-mobile is-inline-flex-tablet">
        <div class="navbar-item">
          <div class="buttons" style="align-items: baseline;">
            <div class="icon is-large nav-icon" v-if="recentSearch.length > 0">
              <b-tooltip
                type="is-light"
                :label="`${recentSearch.length} búsquedas recientes`"
                position="is-bottom"
                :active="!isMobile"
              >
                <span
                  @click="onClickToggleRecentSearchBox"
                  class="is-size-3"
                  :class="{ 'icon-active': showRecentSearchBox }"
                  >♻</span
                >
              </b-tooltip>
              <span class="badge" v-if="recentSearch.length > 0">{{
                recentSearch.length
              }}</span>
            </div>
            <span class="icon is-large nav-icon">
              <b-tooltip
                v-if="
                  pageType === 'bookmarks' ||
                    isMobile ||
                    bookmarkAlbums.length === 0
                "
                type="is-light"
                :label="`${bookmarkAlbums.length} productos en favoritos`"
                position="is-bottom"
                :active="!isMobile"
              >
                <span
                  @click="onClickShowBookmarks"
                  class="fas fa-2x is-size-4"
                  :class="[
                    { 'icon-active': pageType === 'bookmarks' },
                    settings.bookmarkIcon
                  ]"
                ></span>
              </b-tooltip>
              <!-- Dropdown -->
              <b-dropdown v-else hoverable position="is-bottom-left">
                <span
                  slot="trigger"
                  @click="onClickShowBookmarks"
                  class="fas fa-2x is-size-4"
                  :class="[
                    { 'icon-active': pageType === 'bookmarks' },
                    settings.bookmarkIcon
                  ]"
                ></span>
                <b-dropdown-item
                  v-for="(album, index) in latestBookmarkAlbums"
                  :key="index"
                  @click="$emit('clickAlbumName', album)"
                >
                  <article class="media">
                    <figure class="media-left">
                      <p class="image is-64x64 ">
                        <img :src="album.image_url | image(100)" />
                      </p>
                    </figure>
                    <div class="media-content  overflow-content">
                      <div class="content ">
                        <p>
                          <strong>{{ album.name }}</strong>
                          <br />
                          {{ album.price | priceFormat }}
                        </p>
                      </div>
                    </div>
                  </article>
                </b-dropdown-item>
                <b-dropdown-item
                  class="has-text-centered"
                  v-if="bookmarkAlbums.length > showItemsBookmark"
                  @click="onClickShowBookmarks"
                  >Ver todo
                </b-dropdown-item>
              </b-dropdown>
              <span class="badge" v-if="bookmarkAlbums.length > 0">{{
                bookmarkAlbums.length
              }}</span>
            </span>
            <span class="icon is-large nav-icon">
              <b-tooltip
                type="is-light"
                label="Ajustes"
                position="is-bottom"
                :active="!isMobile"
              >
                <span @click="onClickSettings" class="is-size-3">🛠</span>
              </b-tooltip>
            </span>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "TheNavbar",
  data() {
    return {
      showItemsBookmark: 5
    };
  },
  props: {
    showRecentSearchBox: {
      type: Boolean,
      required: true
    },
    recentSearch: {
      type: Array,
      required: true
    },
    pageType: {
      type: String,
      required: true
    },
    bookmarkAlbums: {
      type: Array,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    latestBookmarkAlbums() {
      return this.bookmarkAlbums.slice(0, this.showItemsBookmark);
    }
  },
  methods: {
    onClickToggleRecentSearchBox() {
      this.$emit("clickToggleRecentSearchBox");
    },
    onClickShowBookmarks() {
      this.$emit("clickShowBookmarks");
    },
    onClickTitle() {
      this.$emit("clickTitle");
    },
    onClickSettings() {
      this.$emit("clickSettings");
    }
  }
};
</script>

<style scoped>
a.dropdown-item {
  padding-right: 1rem;
  border-bottom: 1px solid #ccc;
}
img {
  max-height: 100px !important;
}
.navbar-item {
  cursor: pointer;
}
.badge {
  position: absolute;
  right: -2px;
  top: 4px;
  display: inline-block;
  min-width: 19px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  line-height: 1.43;
  vertical-align: text-top;
  white-space: nowrap;
  text-align: center;
  text-shadow: none;
  background-clip: padding-box;
  background-color: #ec5252;
  border: none;
  border-radius: 15px;
  z-index: 1;
}
.nav-icon {
  position: relative;
  margin-left: 10px;
}
.fas {
  color: #ccc;
}
.fas:hover {
  color: #fff;
}
.icon-inactive {
  color: #ccc;
}
.icon-active {
  color: #fff;
}
.is-gradient {
  background-color: #008a94;
  background-image: linear-gradient(326deg, #00c8d6, #008a94 94%);
}
.navbar-item {
  color: #fff !important;
}
.navbar-end {
  -webkit-box-pack: end !important;
  -ms-flex-pack: end !important;
  justify-content: flex-end !important;
}
</style>
